import React from 'react';

export const authRouteConfig = [
	{
		routes: [
			{
				path: '/auth',
				component: React.memo(() => {
					React.useEffect(() => {
						globalThis.location.href = 'https://patients.healthmedocs.com/sign-in';
					}, []);
					return null;
				}),
			},
		],
	},
	{
		routes: [
			{
				path: '/error-pages/error-404',
				component: React.lazy(() => import('../errorPages/Error404/index')),
			},
		],
	},
];
